import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_LABORATORY_ID,
    ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_ID,

    ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE,

    ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE,

    ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE,

    ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE,

    ILaboratoryConfidentialityDeedLoadByLaboratoryIdAction,
    ILaboratoryConfidentialityDeedLoadByIdAction,
    ILaboratoryConfidentialityDeedLoadFailureAction,
    ILaboratoryConfidentialityDeedLoadSuccessAction,

    ILaboratoryConfidentialityDeedSaveAction,
    ILaboratoryConfidentialityDeedSaveSuccessAction,
    ILaboratoryConfidentialityDeedSaveFailureAction,

    ILaboratoryConfidentialityDeedCreateAction,
    ILaboratoryConfidentialityDeedCreateSuccessAction,
    ILaboratoryConfidentialityDeedCreateFailureAction,

    ILaboratoryConfidentialityDeedDeleteAction,
    ILaboratoryConfidentialityDeedDeleteSuccessAction,
    ILaboratoryConfidentialityDeedDeleteFailureAction,

    ILaboratoryConfidentialityDeedValidateAction,
    ILaboratoryConfidentialityDeedValidateSuccessAction,
    ILaboratoryConfidentialityDeedValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/laboratoryConfidentialityDeed";
import { laboratoryConfidentialityDeedApi } from "../services/laboratoryConfidentialityDeed";

export const
    getLaboratoryConfidentialityDeedByLaboratoryIdEpic = (action$): Observable<ILaboratoryConfidentialityDeedLoadSuccessAction | ILaboratoryConfidentialityDeedLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: ILaboratoryConfidentialityDeedLoadByLaboratoryIdAction) => {
                return laboratoryConfidentialityDeedApi
                    .getLaboratoryConfidentialityDeedByLaboratoryId(action.laboratoryId)
                    .map(response =>
                        LoadSuccess(response.laboratoryConfidentialityDeed, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getLaboratoryConfidentialityDeedByIdEpic = (action$): Observable<ILaboratoryConfidentialityDeedLoadSuccessAction | ILaboratoryConfidentialityDeedLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONFIDENTIALITYDEED_LOAD_BY_ID)
            .mergeMap((action: ILaboratoryConfidentialityDeedLoadByIdAction) => {
                return laboratoryConfidentialityDeedApi
                    .getLaboratoryConfidentialityDeedById(action.id)
                    .map(response =>
                        LoadSuccess(response.laboratoryConfidentialityDeed, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setLaboratoryConfidentialityDeedEpic = (action$): Observable<ILaboratoryConfidentialityDeedSaveSuccessAction | ILaboratoryConfidentialityDeedSaveFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONFIDENTIALITYDEED_SAVE)
            .mergeMap((action: ILaboratoryConfidentialityDeedSaveAction) => {
                return laboratoryConfidentialityDeedApi
                    .setLaboratoryConfidentialityDeed(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.laboratoryConfidentialityDeed, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createLaboratoryConfidentialityDeedEpic = (action$): Observable<ILaboratoryConfidentialityDeedCreateSuccessAction | ILaboratoryConfidentialityDeedCreateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONFIDENTIALITYDEED_CREATE)
            .mergeMap((action: ILaboratoryConfidentialityDeedCreateAction) => {
                return laboratoryConfidentialityDeedApi
                    .createLaboratoryConfidentialityDeed(action.laboratoryId)
                    .map(response =>
                        CreateSuccess(
                            response.laboratoryConfidentialityDeed,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    deleteLaboratoryConfidentialityDeedEpic = (action$): Observable<ILaboratoryConfidentialityDeedDeleteSuccessAction | ILaboratoryConfidentialityDeedDeleteFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONFIDENTIALITYDEED_DELETE)
            .mergeMap((action: ILaboratoryConfidentialityDeedDeleteAction) => {
                return laboratoryConfidentialityDeedApi
                    .deleteLaboratoryConfidentialityDeed(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    },
    validateLaboratoryConfidentialityDeedEpic = (action$): Observable<ILaboratoryConfidentialityDeedValidateSuccessAction | ILaboratoryConfidentialityDeedValidateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONFIDENTIALITYDEED_VALIDATE)
            .mergeMap((action: ILaboratoryConfidentialityDeedValidateAction) => {
                return laboratoryConfidentialityDeedApi
                    .validateLaboratoryConfidentialityDeed(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.laboratoryConfidentialityDeed, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }